module.exports = __webpack_public_path__ + "static/research-aa3de966575d729728169c2f8e41c2cc.png";